<template>
  <div class="saveShareHolders">
  <div class="w-100" >

    <!-- First Row : title (shareholder number) -->
    <div class="shareholderTitle">
      {{ $t('iframe_page.shareholder_label') }} {{ shareholderNumber }}
    </div>
    <div class="w-100">
      <document-pi-V2
      :title="$t('iframe_page.doctypes.id')"
      :subTitle="$t('iframe_page.docdesc.id')"
      v-model="idDocs"
      @showInputs="showInputs = true"
      @validateBtn="validateBtn">
      </document-pi-V2>
      <!-- Last rows : Information about Document owner -->
      <div v-if="showInputs || hasSavedInputs">
        <div class="allRow">
          <!-- Document owner gender -->
          <div class="rowLeft selectionBloc genderBlock" @click="changeGenderTo('female')"
            :class="{selectionBlocActive : gender === 'female'}" style="margin-bottom: 10px;">
            {{ $t('iframe_page.mistress') }}
          </div>
          <div class="rowRight selectionBloc genderBlock" @click="changeGenderTo('male')"
            :class="{selectionBlocActive : gender === 'male'}" style="margin-bottom: 10px;">
            {{ $t('iframe_page.mister') }}
          </div>
        </div>
        <p class="mt-0"><small v-if="gender !== 'female' && gender !== 'male'" class="d-flex text-danger pl-2">{{ $t('errors.is_mandatory', { mandatoryValue: this.$t('iframe_page.gender') }) }}</small></p>

        <!-- Document owner other information -->
        <div class="allRow">

          <adaptative-placeholder-input
            :label="$t('iframe_page.firstname')"
            class="rowLeft"
            v-model="firstname"
            :onBlur="checkFirstname"
            :hasError="firstnameHasError"
            :errorMessage="firstnameErrorMessage">
          </adaptative-placeholder-input>

          <adaptative-placeholder-input
            :label="$t('iframe_page.lastname')"
            class="rowRight"
            v-model="lastname"
            :onBlur="checkLastname"
            :hasError="lastnameHasError"
            :errorMessage="lastnameErrorMessage">
          </adaptative-placeholder-input>
        </div>

        <div class="allRow">
          <adaptative-placeholder-input
            :label="$t('iframe_page.birthdate')"
            class="rowLeft"
            v-model="birthdate"
            :onBlur="checkBirthdate"
            :hasError="birthdateHasError"
            :errorMessage="birthdateErrorMessage">
          </adaptative-placeholder-input>

          <adaptative-placeholder-input
            :label="$t('iframe_page.birthtown')"
            class="rowRight"
            v-model="birthtown"
            :onBlur="checkBirthtown"
            :hasError="birthtownHasError"
            :errorMessage="birthtownErrorMessage">
          </adaptative-placeholder-input>
        </div>

        <div class="allRow">
          <adaptative-placeholder-input
            :label="$t('iframe_page.birthcountry')"
            class="rowLeft"
            v-model="birthcountry"
            :onBlur="checkBirthcountry"
            :hasError="birthcountryHasError"
            :errorMessage="birthcountryErrorMessage">
          </adaptative-placeholder-input>

          <adaptative-placeholder-input
            :label="$t('iframe_page.nationality')"
            class="rowRight"
            v-model="nationality"
            :onBlur="checkNationality"
            :hasError="nationalityHasError"
            :errorMessage="nationalityErrorMessage">
          </adaptative-placeholder-input>
        </div>

        <div class="w-100">
          <adaptative-placeholder-input
            :label="$t('iframe_page.id_card_number')"
            v-model="id_card_number"
            :onBlur="checkIdCard"
            :hasError="idCardHasError"
            :errorMessage="idCardErrorMessage">
          </adaptative-placeholder-input>
        </div>

        <div class="w-100">
          <adaptative-placeholder-input
            :label="$t('iframe_page.percentage')"
            v-model="percentage"
            :inputFormating="percentageFormating"
            :onBlur="checkPercentage"
            :hasError="percentageHasError"
            :errorMessage="percentageErrorMessage">
          </adaptative-placeholder-input>
        </div>
        <br>
        <document-proof-address
          :title="$t('iframe_page.doctypes.proof_address')"
          :subTitle="$t('iframe_page.docdesc.proof_address')"
          v-model="proofOfAdress">
        </document-proof-address>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import _ from 'lodash'

import DocumentPiV2 from './DocumentPiV2.vue'
import DocumentProofAddress from './DocumentProofAddress.vue'
import AdaptativePlaceholderInput from './AdaptativePlaceholderInput.vue'

import '../LMSGstyle.css'

export default {
  name: 'Shareholder',
  props: {
    documents: {
      type: Array,
      default: function () {
        return []
      }
    },
    errorMessage: {
      type: String,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    },
    shareholderMaxNumber: {
      type: Number,
      default: ''
    },
    shareholderNumber: {
      type: Number,
      default: ''
    },
    value: {
      type: Object,
      default: function () {
        return []
      }
    }
  },
  components: {
    'document-pi-V2': DocumentPiV2,
    'document-proof-address': DocumentProofAddress,
    'adaptative-placeholder-input': AdaptativePlaceholderInput
  },
  computed: {
    hasSavedInputs () {
      return this.firstname ||
              this.lastname ||
              this.gender ||
              this.birthdate ||
              this.birthtown ||
              this.birthcountry ||
              this.nationality ||
              this.id_card_number ||
              this.percentage
    },
    isWaiting () {
      return this.statusId === this.status.VERIFYING
    },
    proofOfAdress: {
      get () {
        return this.uboInfos.proofOfAdress
      },
      set (val) {
        let tmp = _.cloneDeep(this.value)
        tmp.proofOfAdress = val
        this.$emit('input', tmp)
      }
    },
    uboInfos: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    idDocs: {
      get () {
        return this.uboInfos.documents
      },
      set (val) {
        let uboInfosTmp = _.cloneDeep(this.uboInfos)
        uboInfosTmp.documents = val
        this.$emit('input', uboInfosTmp)
      }
    },
    firstname: {
      get () {
        return this.uboInfos.firstname
      },
      set (val) {
        let tmp = _.cloneDeep(this.uboInfos)
        tmp.firstname = val
        this.$emit('input', tmp)
      }
    },
    lastname: {
      get () {
        return this.uboInfos.lastname
      },
      set (val) {
        let tmp = _.cloneDeep(this.uboInfos)
        tmp.lastname = val
        this.$emit('input', tmp)
      }
    },
    gender: {
      get () {
        return this.uboInfos.gender
      },
      set (val) {
        let tmp = _.cloneDeep(this.uboInfos)
        tmp.gender = val
        this.$emit('input', tmp)
      }
    },
    birthdate: {
      get () {
        return this.uboInfos.birthdate
      },
      set (val) {
        let tmp = _.cloneDeep(this.uboInfos)
        tmp.birthdate = val
        this.$emit('input', tmp)
      }
    },
    birthtown: {
      get () {
        return this.uboInfos.birthtown
      },
      set (val) {
        let tmp = _.cloneDeep(this.uboInfos)
        tmp.birthtown = val
        this.$emit('input', tmp)
      }
    },
    birthcountry: {
      get () {
        return this.uboInfos.birthcountry
      },
      set (val) {
        let tmp = _.cloneDeep(this.uboInfos)
        tmp.birthcountry = val
        this.$emit('input', tmp)
      }
    },
    nationality: {
      get () {
        return this.uboInfos.nationality
      },
      set (val) {
        let tmp = _.cloneDeep(this.uboInfos)
        tmp.nationality = val
        this.$emit('input', tmp)
      }
    },
    id_card_number: {
      get () {
        return this.uboInfos.id_card_number
      },
      set (val) {
        let tmp = _.cloneDeep(this.uboInfos)
        tmp.id_card_number = val
        this.$emit('input', tmp)
      }
    },
    percentage: {
      get () {
        return this.uboInfos.percentage
      },
      set (val) {
        let tmp = _.cloneDeep(this.uboInfos)
        tmp.percentage = val
        this.$emit('input', tmp)
      }
    }
  },
  data () {
    return {
      shareholderDocumentList: ['id'],
      maxPercentage: [],
      docstatus: '2',
      isDocUploaded: false,
      showInputs: false,
      percentageHasError: false,
      percentageErrorMessage: '',
      selectionBlocActiveHasError: false,
      selectionBlocActiveErrorMessage: '',
      firstnameHasError: false,
      firstnameErrorMessage: '',
      lastnameHasError: false,
      lastnameErrorMessage: '',
      birthdateHasError: false,
      birthdateErrorMessage: '',
      birthtownHasError: false,
      birthtownErrorMessage: '',
      birthcountryHasError: false,
      birthcountryErrorMessage: '',
      nationalityHasError: false,
      nationalityErrorMessage: '',
      idCardHasError: false,
      idCardErrorMessage: '',
      isHidden: false,
      isHidden_2: false,
      uboProofAdress: [],
      status: {
        TO_COMPLETE: [0],
        VERIFYING: [11, 13, 16, 30, 31],
        EXPIRED: [15],
        VALIDATED: [33],
        REFUSED: [12, 14, 32, 34]
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    changeGenderTo (newGender) {
      this.gender = newGender
    },
    checkBirthcountry () {
      if (!this.birthcountry || !this.birthcountry.length) {
        this.birthcountryHasError = true
        this.birthcountryErrorMessage = this.$t('errors.is_mandatory', { mandatoryValue: this.$t('iframe_page.birthcountry') })
      } else {
        this.birthcountryHasError = false
      }
    },
    checkBirthdate () {
      if (!this.birthdate || !this.birthdate.length) {
        this.birthdateHasError = true
        this.birthdateErrorMessage = this.$t('errors.is_mandatory', { mandatoryValue: this.$t('iframe_page.birthdate') })
      } else {
        this.birthdateHasError = false
      }
    },
    checkBirthtown () {
      if (!this.birthtown || !this.birthtown.length) {
        this.birthtownHasError = true
        this.birthtownErrorMessage = this.$t('errors.is_mandatory', { mandatoryValue: this.$t('iframe_page.birthtown') })
      } else {
        this.birthtownHasError = false
      }
    },
    checkFirstname () {
      if (!this.firstname || !this.firstname.length) {
        this.firstnameHasError = true
        this.firstnameErrorMessage = this.$t('errors.is_mandatory', { mandatoryValue: this.$t('iframe_page.firstname') })
      } else {
        this.firstnameHasError = false
      }
    },
    checkIdCard () {
      if (!this.id_card_number || !this.id_card_number.length) {
        this.idCardHasError = true
        this.idCardErrorMessage = this.$t('errors.is_mandatory', { mandatoryValue: this.$t('iframe_page.id_card_number') })
      } else {
        this.idCardHasError = false
      }
    },
    checkLastname () {
      if (!this.lastname || !this.lastname.length) {
        this.lastnameHasError = true
        this.lastnameErrorMessage = this.$t('errors.is_mandatory', { mandatoryValue: this.$t('iframe_page.lastname') })
      } else {
        this.lastnameHasError = false
      }
    },
    checkNationality () {
      if (!this.nationality || !this.nationality.length) {
        this.nationalityHasError = true
        this.nationalityErrorMessage = this.$t('errors.is_mandatory', { mandatoryValue: this.$t('iframe_page.nationality') })
      } else {
        this.nationalityHasError = false
      }
    },
    checkPercentage () {
      if (!this.percentage || !this.percentage.length) {
        this.percentageHasError = true
        this.percentageErrorMessage = this.$t('errors.is_mandatory', { mandatoryValue: this.$t('iframe_page.percentage') })
      } else if (parseFloat(this.percentage) < 25 || parseFloat(this.percentage) > 100) {
        this.percentageHasError = true
        this.percentageErrorMessage = this.$t('errors.percentage_detention_between')
      } else {
        this.percentageHasError = false
      }
    },
    filesUploaded (files) {
      if (files.length) {
        this.isDocUploaded = true
      }
      this.fileList = files
    },
    percentageFormating (val) {
      // regex to match floating number from 0 to 999.99 with a possible % character
      let match = val.match('^[0-9]{1,3}(?:[.,][0-9]{0,2}){0,1}[%]{0,1}$')
      if (!val) {
        return ''
      } else if (match && match.length === 1) {
        return val
      } else {
        this.percentage = this.percentage
        return this.percentage
      }
    },
    saveDocs (files) {
      if (files.length) {
        this.isDocUploaded = true
      }
      this.uboProofAdress.push(files)
    },
    validateBtn () {
      this.showInputs = true
      let tmp = _.cloneDeep(this.uboInfos)
      tmp.documents = this.idDocs
      this.$emit('input', tmp)
    }
  }
}
</script>
<style scoped>
.shareholderTitle {
  font-weight: bold;
  font-family: Ubuntu-L;
  font-size: 19px;
}
.btn-next {
  background-color: #49A0A2;
}
.btn-next-2 {
  margin-bottom: 10%;
  margin-top: -10%;
  background-color: #49A0A2;
}
.whatDeclaration {
  width: 100%;
}
.rowLeft {
  margin-right: 2%;
  width: 48%;
}
.rowRight {
  margin-left: 2%;
  width: 48%;
}
.styleSaveDeclaration {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  text-decoration-line: underline;
  color: #49A0A2;
  margin-left: 3%;
  background-color: white;
  border: none;
  margin-top: 4%;
}
.styleSaveDeclarationLocked {
  background-color: #c8e3e3;
  margin-top: -25%;
}
.pos-svg {
  margin-left: auto;
  margin-right: auto;
  margin-top: 20%;
  margin-bottom: 10%;
  width: 100%;
}

.style-btn-document {
  background: #FFFFFF;
  border: 1px solid #49A0A2;
  border-radius: 2px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: #49A0A2;
}
.style-btn-chantier {
  background: #49A0A2;
  border-radius: 2px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: #FFFFFF;
}
</style>
